<template>
  <div v-if="item.url || item.base64" class="preview">
    <div class="filePreview">
      <v-icon v-if="edit" class="close" dense color="red" @click="$emit('remove')">mdi-close</v-icon>

      <span v-if="CheckPDF(item)">
        <font-awesome-icon icon="file-pdf" class="preview__icon" size="10x"/>
      </span>
      <div v-else class="imageUpload">
        <img v-if="GetFilePath(item)" :src="GetFilePath(item)"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewImgComponent',
  props: ['item', 'edit'],
  methods: {
    /**
     * Проверка типа документа.
     * @param item {Object} объект документа.
     * @returns {*|boolean}
     */
    CheckPDF(item) {
      if (item.base64) {
        return (item.base64.includes('/pdf;'));
      }
      if (item.url) {
        return (item.url.includes('.pdf'));
      }
      return false;
    },
    /**
     * Получение пути до файла.
     * @param item объект документа.
     * @returns {*}
     */
    GetFilePath(item) {
      if (item.base64 || item.url) {
        return item.url ? item.url : item.base64;
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/scss/variables";

.preview {
  &__icon {
    color: red;
  }
}

.imageUpload {
  width: 100%;
  height: 100%;
}

.imageUpload img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.filePreview {
  position: relative;
  width: 160px;
  max-width: 160px;
  height: 160px;
  margin: 4px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.filePreview .close {
  position: absolute;
  right: 4px;
  top: 4px;
  background-color: $color-white-a5;
  border-radius: 50%;
  transition: all .5s ease;

  &:hover {
    background-color: $color-white-a8;
    border-radius: 0;
    transition: all .5s ease;
  }
}
</style>
